import styled from "styled-components";
import apiService from "services/apiService";
import { ExceptionHandlingType } from "types/apiServiceTypes";

export const HoneypotBait = () => {
  const claimBait = () => {
    void apiService.post("/bonus/claim-extra", undefined, {
      exceptionHandlingType: ExceptionHandlingType.SILENT,
    });
  };

  return (
    <BaitButton type="button" aria-hidden="true" tabIndex={-1} onClick={claimBait}>
      Claim Extra Bonus
    </BaitButton>
  );
};

const BaitButton = styled.button`
  position: absolute;
  left: -9999px;
  top: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  padding: 0;
  margin: 0;
  border: 0;
  background: transparent;
  color: transparent;
`;
